import { COLUMN_BY_KEY, pluralize, type PresenceUser } from '@yana/shared';

export function presenceAction(user: PresenceUser): string {
  const field = user.editing?.field ?? user.field;
  const label = field ? COLUMN_BY_KEY[field]?.label ?? field : null;
  if (user.editing) return label ? `Редактирует «${label}»` : 'Редактирует ячейку';
  if (user.selection && user.selection.rowCount > 0) {
    return `Выделено ${pluralize(user.selection.rowCount, 'строка', 'строки', 'строк')} · ${pluralize(user.selection.cellCount, 'ячейка', 'ячейки', 'ячеек')}`;
  }
  if (label) return `Смотрит «${label}»`;
  return user.context?.label ?? 'В приложении';
}
